import { Component, OnInit, Input } from '@angular/core';

// env
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-slider-banner',
  templateUrl: './slider-banner.component.html'
})
export class SliderBannerComponent implements OnInit {

  @Input() dataBannerSlider;
  apiAsset = environment.API_ASSETS;
  slideConfig = {
    "slidesToShow": 1, 
    "arrows": false,
    "autoplay": true,
    "slidesToScroll": 1,
    "dots": true
  };

  
  constructor() { }

  ngOnInit(): void {

  }

}
